import { ServiceState } from '../../rz-status_models';
import React from 'react';
import StateIcon from './StateIcon';
import Constants from '../../rz-status_constants';
import { useState } from 'react';

export default function({data, onChange, disabled = false}:{data: ServiceState[], onChange: (e:ServiceState[]) => {}, disabled: boolean}) {
    const [isExpanded, setExpanded] = useState(false);
    const entries = Object.entries(ServiceState).filter(([key]) => isNaN(Number(key)));

    function clickHandler(option: ServiceState) {
        if(data.includes(option)) {
        onChange(data.filter(o => o != option))
        }
        else {
        onChange([...data, option].sort())
        }
    }

    if(data == null)
        return <></>
    return <>
        <button className="button" id="filter-headline" onClick={() => setExpanded(!isExpanded)} aria-expanded={isExpanded ? "true" : "false"} aria-controls="filter" aria-label={`Filter ${isExpanded ? "ausblenden" : "anzeigen"}`}><span className="icon filter"/>Filter</button>
        <search aria-label="Serviceübersicht filtern">
            <fieldset id="filter" className={"collapsible-content collapsible-mobile" + (isExpanded ? " open" : "") + (disabled ? " disabled" : "")}>
                {entries.map(([value, key]) =><span key={key} className="checkbox">
                        <input type="checkbox" id={"filter"+key} name={key} value={key} disabled={disabled} onChange={() => clickHandler(key)} checked={data.includes(key)}/>
                        <label htmlFor={"filter"+key}><StateIcon state={key as ServiceState}/> {Constants.stateToName[key]}</label>
                    </span>)
                }
            </fieldset>
        </search>
    </>
}